<span class="w-100 hero-container" fxLayout="row" #container>
  <ng-container *ngIf="getSlide(activeIdx) as slide; else placeholder">
    <span class="position-relative w-100 h-100" [ngStyle]="{
        'transition': 'background-image 0.5s linear',
        'background-image': 'url(' + slide.imagehigh + ')',
        'background-size': 'cover',
        'background-position': 'center'
      }" (swiperight)="restartInterval() && prev()" (swipeleft)="restartInterval() && next()">
      <div fxFill fxLayout="row" fxLayoutAlign="center end" (click)="goTo(slide)" class="position-relative cursor">

        <div class="position-absolute h-50 w-100 top-50 overlay-shade zindex-overlay"></div>

        <div fxLayout="column" fxFlex="0 1 900px" fxFlex.sm="1 1 100" fxFlex.xs="1 1 100">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.sm="start end" fxLayoutAlign.xs="start end"
            fxFill>
            <div fxFlex="60px" class="desktop-only"></div>
            <div fxFlex="20px" class="mobile-only"></div>
            <div fxLayout="column" fxFlex fxFill fxLayoutGap="1px" class="zindex-content">
              <span class="slide-overline f-hero-overline">{{slide.topos | uppercase}}</span>
              <span class="slide-headline f-hero-headline">{{slide.title}}</span>
              <span class="slide-subline f-hero-subline">{{slide.unterschrift_hero}}</span>
              <div class="desktop-only" fxFlex="55px"></div>
              <div class="mobile-only" fxFlex="35px"></div>
            </div>
            <div fxFlex="60px" fxFlex.xs="10px"></div>
          </div>
        </div>

        <!-- <span class="px-3 pb-3 zindex-overlay" fxLayout="row" fxLayoutAlign="bottom end">
          <img *ngIf="slide?.rating === 4"
          [alt]="'searchList.selectors.ratingOptions.4' | translate" src="assets/media/rating_badge.svg"
          class="mt-auto mb-4 res-image-height-widht-58-36" />
          <div fxFlex="10px"></div>

          <app-age-category-badge [ageCategory]="slide?.altersfreigabe" *ngIf="slide?.rating > 2"
            class="mt-auto res-image-height-widht-58-36" />
          <div fxFlex="10px"></div>
          <app-traffic-lights class="res-image-height-width-148-76x58-30 res-pad-t-50-0"
            [rating]="slide?.rating"></app-traffic-lights>
        </span> -->
      </div>

      <img src="assets/media/hover_arrows_hero_left.svg" [alt]="'common.left' | translate"
        class="left-arrow position-absolute absolute-zero clickable" height="82" width="54"
        (click)="$event.stopPropagation()  || restartInterval() && prev()" />
      <img src="assets/media/hover_arrows_hero_right.svg" [alt]="'common.right' | translate" height="82" width="54"
        class="right-arrow position-absolute absolute-zero clickable"
        (click)="$event.stopPropagation() || restartInterval() && next()" />
      <div #indicators fxLayout="row" class="position-absolute indicators" fxLayoutGap="5px">
        <span class="indicator" *ngFor="let s of slides; let i = index"
          [ngStyle]="{background: activeIdx === i ? '#FF522E' : 'white'}"></span>
      </div>
    </span>

    <!--CACHE IMAGES BEFORE PAGING-->
    <img *ngFor="let slideImage of slides; let i = index" [src]="slideImage.imagehigh" hidden fetchpriority="high"
      [loading]="index === 0 ?'eager' : 'lazy'">
  </ng-container>
  <ng-template #placeholder>
    <span *ngIf="placeholderPreviewItem" class="position-relative w-100 h-100" [ngStyle]="{
      'background-image': 'url(' + placeholderPreviewItem.imagehigh + ')',
      'background-size': 'cover',
      'background-position': 'center'}">
      <div fxFill fxLayout="row" fxLayoutAlign="center end" class="position-relative cursor">
        <div class="position-absolute h-50 w-100 top-50 overlay-shade zindex-overlay"></div>
        <div fxLayout="column" fxFlex="0 1 900px" fxFlex.sm="1 1 100" fxFlex.xs="1 1 100">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.sm="start end" fxLayoutAlign.xs="start end"
            fxFill>
            <div fxFlex="60px" fxFlex.xs="20px"></div>
            <div fxLayout="column" fxFlex fxFill fxLayoutGap="1px" class="zindex-content">
              <span class="slide-overline f-hero-overline">{{slide.topos | uppercase}}</span>
              <span class="slide-headline f-hero-headline">{{slide.title}}</span>
              <span class="slide-subline f-hero-subline">{{slide.unterschrift_hero}}</span>
              <div class="desktop-only" fxFlex="55px"></div>
              <div class="mobile-only" fxFlex="35px"></div>
            </div>
            <div fxFlex="60px" fxFlex.xs="10px"></div>
          </div>
        </div>
      </div>
    </span>
  </ng-template>
</span>